import { render, staticRenderFns } from "./StoreHome.vue?vue&type=template&id=f4b016ac&scoped=true&"
import script from "./StoreHome.vue?vue&type=script&lang=js&"
export * from "./StoreHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b016ac",
  null
  
)

export default component.exports